<template>
  <div :class="['bg-(--color-bg)']">
    <CommonBreadcrumb />

    <CommonBanner
      :bg-url="props.bannerImg || mdData?.bannerImg || '/img/bg/home-1.avif'"
      :title="t(`page.${curRouteName}.title`)"
      :desc="t(`page.${curRouteName}.subTitle`)"
      :transparent="false"
      class="page_body"
    />

    <CommonGroupMenu v-if="props.groupMenu" :list="props.groupMenu" />

    <CommonTipSupportLang v-if="mdData" />

    <div :class="['page_view', 'flex flex-col lg:gap-12 gap-8', 'lg:py-20 py-15']">
      <!-- 如果是文章 -->
      <ContentRenderer v-if="mdData" class="whitespace-pre-wrap" :value="mdData" />
      <!-- 否则页面插槽接收自定义内容 -->
      <slot v-else />

      <!-- 联系电话卡片容器 -->
      <CommonContactCard v-if="props.showFooter" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { AppComponentItem } from '~/types/common/item'

  interface IntroArticle {
    groupMenu?: AppComponentItem[]
    bannerImg?: string
    showFooter?: boolean
  }
  const props = withDefaults(defineProps<IntroArticle>(), {
    showFooter: true,
  })

  const { t } = useI18n()
  const { formatPathDot } = useI18nTools()
  /** 格式化后的当前路由名称 */
  const curRouteName = formatPathDot()

  // 获取文章数据
  const { getArticle } = useI18nContent()
  /** 文章md数据 */
  const { data: mdData } = await getArticle()
</script>
